<button
  (click)="addNewMetric.emit(true)"
  class="add-metric-btn"
>
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 10.5C0.5 4.99219 4.95312 0.5 10.5 0.5C16.0078 0.5 20.5 4.99219 20.5 10.5C20.5 16.0469 16.0078 20.5 10.5 20.5C4.95312 20.5 0.5 16.0469 0.5 10.5ZM10.5 14.875C11.0078 14.875 11.4375 14.4844 11.4375 13.9375V11.4375H13.9375C14.4453 11.4375 14.875 11.0469 14.875 10.5C14.875 9.99219 14.4453 9.5625 13.9375 9.5625H11.4375V7.0625C11.4375 6.55469 11.0078 6.125 10.5 6.125C9.95312 6.125 9.5625 6.55469 9.5625 7.0625V9.5625H7.0625C6.51562 9.5625 6.125 9.99219 6.125 10.5C6.125 11.0469 6.51562 11.4375 7.0625 11.4375H9.5625V13.9375C9.5625 14.4844 9.95312 14.875 10.5 14.875Z" fill="currentColor"/>
  </svg>
</button>
